import { Pipe, PipeTransform } from '@angular/core';
import { DossierDto, DossierSearchResultDto } from '@scip/api';
import { DossierUtils } from '../../core';

@Pipe({
  name: 'canDownloadDossier'
})
export class CanDownloadDossierPipe implements PipeTransform {
  transform(dossier: DossierSearchResultDto | DossierDto): boolean {
    return dossier ? DossierUtils.canDownload(dossier) : false;
  }
}
